'use client';

export default function CCPALink() {
  return (
    <a
      href="/privacy#do-not-sell"
      className="text-white/80 hover:text-accent transition-smooth text-sm"
    >
      Neprodat mé osobní údaje
    </a>
  );
}
